
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { EmailManagement } from "./EmailManagement";

interface ProductBasicInfoProps {
  name: string;
  ipAddress: string;
  description: string;
  primaryEmail: string;
  secondaryEmails: string[];
  isSubmitting?: boolean;
  onNameChange: (value: string) => void;
  onIpAddressChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onPrimaryEmailChange: (email: string) => void;
  onSecondaryEmailsChange: (emails: string[]) => void;
}

export const ProductBasicInfo = ({
  name,
  ipAddress,
  description,
  primaryEmail,
  secondaryEmails,
  isSubmitting = false,
  onNameChange,
  onIpAddressChange,
  onDescriptionChange,
  onPrimaryEmailChange,
  onSecondaryEmailsChange,
}: ProductBasicInfoProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="name">Nom du produit</Label>
        <Input
          id="name"
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="Entrez le nom du produit"
          disabled={isSubmitting}
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="ipAddress">Adresse IP</Label>
        <Input
          id="ipAddress"
          value={ipAddress}
          onChange={(e) => onIpAddressChange(e.target.value)}
          placeholder="Entrez l'adresse IP (ex: 192.168.1.1)"
          disabled={isSubmitting}
        />
      </div>

      <EmailManagement
        primaryEmail={primaryEmail}
        secondaryEmails={secondaryEmails}
        isSubmitting={isSubmitting}
        onPrimaryEmailChange={onPrimaryEmailChange}
        onSecondaryEmailsChange={onSecondaryEmailsChange}
      />

      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Textarea
          id="description"
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder="Entrez la description du produit"
          rows={3}
          disabled={isSubmitting}
        />
      </div>
    </>
  );
};
